import { GradientText } from "lola-framework-ui-test";
import { TITLE_COLOR } from "../../constants";
import { FlagCircle } from "../FlagCircle";
import { useStore } from "../../store/globalState";

export interface CurrentExchangeRateCardProps {
  countryIso2: string;
  rate: string;
  currency: string;
  label: string;
}

/**
 * Compact informational FX chip for the fund-request home.
 * Rate and destination currency render on one line.
 */
export const CurrentExchangeRateCard = ({
  countryIso2,
  rate,
  currency,
  label,
}: CurrentExchangeRateCardProps) => {
  const { theme } = useStore();
  const { bodyCopy } = theme.whiteView;

  return (
    <section
      className="current-exchange-rate-card"
      style={{ background: `${bodyCopy}14` }}
    >
      <span className="current-exchange-rate-card__label">
        <FlagCircle iso2={countryIso2.toLowerCase()} size={22} />
        <GradientText
          className="current-exchange-rate-card__label-text"
          textColor={bodyCopy}
        >
          {label}
        </GradientText>
      </span>
      <GradientText
        className="current-exchange-rate-card__rate"
        textColor={TITLE_COLOR}
      >
        {rate} {currency}
      </GradientText>
    </section>
  );
};
